import * as React from "react";
import { CheckIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const STEPS = [
  { num: 1, label: "Category" },
  { num: 2, label: "Configure" },
  { num: 3, label: "Review" },
] as const;

interface WizardStepIndicatorProps {
  step: 1 | 2 | 3;
}

export const WizardStepIndicator: React.FC<WizardStepIndicatorProps> = ({ step }) => (
  <div className="flex items-center justify-between border-b border-slate-100 pb-4 select-none">
    {STEPS.map((wizardStep, idx, arr) => (
      <React.Fragment key={wizardStep.num}>
        <div className="flex items-center gap-2">
          <div
            className={cn(
              "size-6 rounded-full flex items-center justify-center text-xs font-bold font-mono border transition-all duration-200",
              step === wizardStep.num
                ? "bg-primary border-primary text-white ring-4 ring-primary/10"
                : step > wizardStep.num
                ? "bg-emerald-500 border-emerald-500 text-white"
                : "bg-slate-50 border-slate-200 text-slate-400"
            )}
          >
            {step > wizardStep.num ? <CheckIcon className="size-3.5" /> : wizardStep.num}
          </div>
          <span
            className={cn(
              "text-xs font-bold",
              step === wizardStep.num ? "text-slate-800" : step > wizardStep.num ? "text-emerald-600" : "text-slate-400"
            )}
          >
            {wizardStep.label}
          </span>
        </div>
        {idx < arr.length - 1 && <div className="flex-1 h-px bg-slate-200 mx-3" />}
      </React.Fragment>
    ))}
  </div>
);
